var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[(_vm.from)?_c('div',{staticClass:"message"},[_c('h2',[_vm._v("\n      Cannot find resource at "+_vm._s(_vm.from.path)+"\n    ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("← Back home")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f31ca12c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 129
// module chunks = 0